export default __webpack_public_path__ + "static/media/edit.801fcf1e.svg";